import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { selectUserProfiles } from '@app/user/store/selectors/user.selectors';
import { TranslateService } from '@ngx-translate/core';
import { MessageTypeEnum } from '@app/ngrx-message/constants/messageTypeEnum';
import { Message } from '@app/ngrx-message/models/client/message';
import {
  AccessRoleKeyEnum,
  AccessRoleValueEnum,
} from '@shared/constants/order-info-access-role.constant';
import { QuickOrderEntryService } from '@shared/services/quick-order/quick-order-entry.service';

@Injectable({
  providedIn: 'root',
})
export class OrderInfoSidebarService {
  constructor(
    private store: Store,
    private translate: TranslateService,
    private quickOrderEntryService: QuickOrderEntryService,
  ) {}
  orderUserAccessStatus(): Observable<boolean> {
    return this.store.select(selectUserProfiles).pipe(
      filter(userProfiles => !!userProfiles?.length),
      take(1),
      map(val => {
        const accessRolePair = val?.find(
          pair => pair.key === AccessRoleKeyEnum.ACCESS_ROLE_KEYS,
        );
        const accessRole = accessRolePair
          ? accessRolePair.value === AccessRoleValueEnum.NO_SUBMIT_VALUE
          : false;
        return accessRole;
      }),
    );
  }
  orderUserStatusMessage(): Message {
    return {
      id: null,
      type: MessageTypeEnum.warning,
      display: this.translate.instant('i18n.orderPage.cannotSubmitOrder'),
      stack: null,
      watermark: null,
      read: null,
      sticky: true,
    };
  }
}
